module.exports = __webpack_public_path__ + "static/media/chhitosewa-thumbnail-1-hd.750a0acd.jpg";